import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

export const currentUserIsGameMasterSelector = createSelector(
  (state: RootState) => state.game.game?.masterUserId,
  (state: RootState) => state.auth.user?.uid,
  (masterUserId, uid) => {
    return masterUserId === uid && masterUserId !== undefined;
  }
);
